var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitewhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(-5117 -5736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cb23875ab0a12b500ec3e6df6ac960fc",
    transform: "translate(5100.236 5721.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M32.731,15.8A14.938,14.938,0,0,0,17.8,30.731a14.707,14.707,0,0,0,2.392,8.112l-2.262,5.009a1.357,1.357,0,0,0,.194,1.39,1.443,1.443,0,0,0,1.357.42l6.27-1.713A14.951,14.951,0,1,0,32.731,15.8Zm0,27.277A12.245,12.245,0,0,1,26.526,41.4a1.165,1.165,0,0,0-.646-.194,1.326,1.326,0,0,0-.356.032l-4.1,1.131,1.422-3.135a1.318,1.318,0,0,0-.129-1.293,12.217,12.217,0,0,1-2.327-7.207A12.346,12.346,0,1,1,32.731,43.077Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M54.656,50a2.429,2.429,0,0,0-2.165-.485c-.549.226-.937,1.131-1.293,1.584a.589.589,0,0,1-.711.162,9.78,9.78,0,0,1-4.912-4.2.643.643,0,0,1,.065-.84,3.451,3.451,0,0,0,.9-1.454,3.182,3.182,0,0,0-.388-1.713,3.9,3.9,0,0,0-1.26-1.907,1.69,1.69,0,0,0-1.874.291A3.8,3.8,0,0,0,41.7,44.474a3.336,3.336,0,0,0,.129.97,7.8,7.8,0,0,0,.937,2.133,11.377,11.377,0,0,0,.97,1.454A14.892,14.892,0,0,0,47.9,52.909a12.9,12.9,0,0,0,2.618,1.228,6.155,6.155,0,0,0,3.038.485A3.677,3.677,0,0,0,56.3,52.586a1.917,1.917,0,0,0,.129-1.034C56.208,50.776,55.238,50.356,54.656,50Z",
    transform: "translate(-16.172 -17.039)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    width: 32,
    height: 32,
    transform: "translate(5117 5736)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitewhatsapp);
export default __webpack_public_path__ + "static/media/whitewhatsapp.fc6722c65496fff05fe32b4f7b7bfeb3.svg";
export { ForwardRef as ReactComponent };